import {HttpInterceptorFn} from '@angular/common/http';
import {inject, isDevMode, PLATFORM_ID, REQUEST} from '@angular/core';
import {isPlatformServer} from '@angular/common';

export const cookieForwardingInterceptor: HttpInterceptorFn = (req, next) => {
  const platformId = inject(PLATFORM_ID);
  const serverRequest = inject(REQUEST, {optional: true}) as Request | null;

  if (isPlatformServer(platformId) && serverRequest) {
    const cookie = serverRequest.headers.get('cookie');
    const referer = serverRequest.headers.get('referer');
    const origin = serverRequest.headers.get('origin');

    const headers: Record<string, string> = {};
    if (cookie) headers['Cookie'] = cookie;
    if (isDevMode()) {
      headers['Referer'] = 'http://laavan.test.com';
      headers['Origin'] = 'http://laavan.test.com';
    } else {
      headers['Referer'] = 'https://apnerishte.com';
      headers['Origin'] = 'https://apnerishte.com';
    }
    return next(
      req.clone({
        setHeaders: headers,
        withCredentials: true,
      })
    );
  }

  return next(req);
};
